scrollPage = !1, currenAjax = null, isAutoScrolling = !1;
var sizeStart = 110,
	sizeEnd = 150,
	sizeStarts = 120,
	sizeEnds = 150,
	lensSizeStart = 30,
	lensSizeEnd = 90,
	lensHeightStart = 10,
	lensHeightEnd = 60,
	bridgeSizeStart = 10,
	bridgeSizeEnd = 30,
	priceRangeStart = parseInt($("#price-range-start").attr("data-defaul-min")),
	priceRangeEnd = parseInt($("#price-range-end").attr("data-defaul-max")),
	bannerLoaded = 0,
	dittoTest = !1,
	bannerPosition = [],
	$prescription = $("#js-prescription"),
	$eligible = $("#js-eligible"),
	enablep = $.cookie("enablep");
0 != enablep && null != enablep || "undefined" == typeof filterUrl && "undefined" == typeof mobFilterUrl || (enablep = 0, $.cookie("enablep", 1, {
	expires: 180,
	path: "/"
})), -1 == filterUrl.indexOf("enablep") && (-1 == filterUrl.indexOf("=") ? filterUrl += "?enablep=" + enablep : filterUrl += "&enablep=" + enablep), -1 == mobFilterUrl.indexOf("enablep") && (-1 == mobFilterUrl.indexOf("=") ? mobFilterUrl += "?enablep=" + enablep : mobFilterUrl += "&enablep=" + enablep);
var upateSmallBannerPosition = function(initializate) {
		var line_num = 3 < (line_num = Math.ceil($(".products-list").outerWidth() / $(".products-list li").outerWidth())) ? 3 : line_num;
		$(".add-pic").each(function(index) {
			if ($(this).hasClass("none")) return 1 == dittoTest && (position = (bannerPosition = $(this).data("position"))[index] * line_num - 1, $(this).removeClass("none"), $("#list-inner-banner-" + position).after($(this))), !0;
			var position = $(this).data("position") * line_num - 1;
			1 == dittoTest && 0 < bannerPosition.length && (position = bannerPosition[index] * line_num - 1), 0 < $("#list-inner-banner-" + position).length ? 0 == position ? $("#list-inner-banner-" + position).before($(this)) : $("#list-inner-banner-" + position).after($(this)) : $(this).remove()
		}), 1 == initializate && $("#add-pic").remove()
	},
	upateCatalogSeoPosition = function(initializate) {
		var line_num = 3 < (line_num = Math.ceil($(".products-list").outerWidth() / $(".products-list li").outerWidth())) ? 3 : line_num,
			insert_num = [];
		$(".add-pic-catalog").each(function() {
			var replace, position = $(this).data("position") * line_num - 1;
			0 < $("#list-inner-banner-" + position).length ? (0 == position ? $("#list-inner-banner-" + position).before($(this)) : $("#list-inner-banner-" + position).after($(this)), insert_num.push({
				position: position,
				element: $(this)
			})) : 1 == insert_num.length && 1 == $(this).data("replace") ? ((replace = insert_num[0]).element.remove(), 0 == replace.position ? $("#list-inner-banner-" + replace.position).before($(this)) : $("#list-inner-banner-" + replace.position).after($(this))) : $(this).remove()
		})
	},
	ajaxReplaceSmallBanner = function() {
		if (1 === $("#js-small-banner").data("disable")) return !1;
		0 < $("#js-small-banner").length && "php" != $("#js-small-banner").data("getbanner") ? $("#js-small-banner").ajaxAuto({
			data: {
				type: $("#js-small-banner").data("type"),
				"page-url": $("#js-small-banner").data("url")
			},
			success: function(re) {
				$("#js-small-banner #add-pic").html(re.data.html), upateSmallBannerPosition(!0)
			}
		}) : upateSmallBannerPosition(!0)
	};
$.execute = function(params) {
	currenAjax && currenAjax.abort()
}, $.ajaxListLoad = function(params) {
    
	var param = (params.attrs && params.attrs != "") ? params.attrs.join("+") : "";
  		param = param.replace(" ", "-");
	var sort = params.sort ? params.sort : "";
	var handle = $("#js-filter-out").attr("data-collection");
	var currentPage = params.page;
	var url = '/collections/' + handle + "/"+param+"?view=ajax&sort_by="+sort+"&page=" + currentPage;
	
	$.ajax({
      url: url,
      success: function (data) {
      	$(".products-list-container").html(data);
      	$(".ajax-layer").hide()
      },
      beforeSend: function() {
		$(".ajax-layer").show();
		var pos = document.getElementById("list-layer").getBoundingClientRect(),
			top = 0 <= pos.top ? pos.bottom - pos.top >= $(window).height() ? ($(window).height() - pos.top) / 2 - 32 : (pos.bottom - pos.top) / 2 - 32 : pos.bottom >= $(window).height() ? $(window).height() / 2 - 32 - pos.top : pos.bottom / 2 - 32 - pos.top;
		$(".ajax-layer").html("<div style='position: relative; top: " + top + "px; text-align: center' class='ajax-loading'>Loading</div>")
	 },
      complete: function() {
		$(".products-loading").hide()
	  },
    });
	return false;
};
var showFilterTitle = function() {
		$("#js-filter li").removeClass("filtered"); 
		$("#js-filter .option").each(function(k) {
			$(this).hasClass("selected") && $(".filter-out").find("li.js-group-" + $(this).data("group")).addClass("filtered")
		});
		if($("#js-filter .filtered").length > 0) {
			$("#js-filter-clear").addClass("selected")
		} else {
			$("#js-filter-clear").removeClass("selected")
		}
	},
	setFilterName = function($this) {
		$("#js-filter li").each(function() {
			var filterName = $(this).find(".js-filtered-name"),
				selectedFileter = [];
			$(this).find(".option-list").children().each(function() {
				var fitlterText;
				$(this).hasClass("selected") && (fitlterText = $(this).data("filter-" + $(this).data("param")), selectedFileter.push(fitlterText))
			});
			var selectedFileterLength = selectedFileter.length;
			0 < selectedFileterLength ? 2 < selectedFileterLength ? filterName.addClass("filtered-name").html(selectedFileter[0] + " (+" + (selectedFileterLength - 1) + ")") : filterName.addClass("filtered-name").html(selectedFileter.join(", ")) : filterName.removeClass("filtered-name").html("")
		})
	},
	scrollToAnchor = function() {
		var scrollto, offset = $(".list-sort-container").offset(),
			adTop = 0;
		0 < $("#promotion-advertise div").length && (adTop = parseInt($("#promotion-advertise div").get(0).offsetHeight)), $(".top-sign-notice").hasClass("none") || device, scrollto = "desktop" == device ? offset.top - 106 - adTop : +offset.top, "phone" == device && (isAutoScrolling = !0), $("html, body").animate({
			scrollTop: scrollto
		}, {
			duration: 500,
			easing: "swing",
			complete: function() {
				isAutoScrolling = !1
			}
		})
	},
	getFilterCondition = function() {
		var attrsArray = [],
			filterArray = {},
			colorArray = [],
			gtypeArray = [],
			weightArray = [],
			brandsArray = [];
		return $.each($("#js-filter-out .option.selected"), function(i, val) {
			var timestamp;
			$(val).hasClass("custom") ? filterArray.attrs || (filterArray.attrs = "") : ("attrs" == $(val).data("param") && (attrsArray.push($(val).data("attrs")), filterArray.attrs = attrsArray.join(",")), "color" == $(val).data("param") && (colorArray.push($(val).data("color")), filterArray.color = colorArray.join(",")), "prescription" == $(val).data("param") && (timestamp = (new Date).getTime(), filterArray.prescription = timestamp), "gtype" == $(val).data("param") && (gtypeArray.push($(val).data("gtype")), filterArray.gtype = gtypeArray.join(",")), "weight" == $(val).data("param") && (weightArray.push($(val).data("weight")), filterArray.weight = weightArray.join(",")), "brands" == $(val).data("param") && (brandsArray.push($(val).data("brands")), filterArray.brands = brandsArray.join(",")))
		}), $("#size-width").val() != sizeStart + "," + sizeEnd && (filterArray.width = $("#size-width").val()), $("#size-length").val() != sizeStarts + "," + sizeEnds && (filterArray.length = $("#size-length").val()), $("#size-lens-width").val() != lensSizeStart + "," + lensSizeEnd && (filterArray.lens = $("#size-lens-width").val()), $("#size-lens-height").val() != lensHeightStart + "," + lensHeightEnd && (filterArray.height = $("#size-lens-height").val()), $("#size-nose-bridge").val() != bridgeSizeStart + "," + bridgeSizeEnd && (filterArray.bridge = $("#size-nose-bridge").val()), 1 == $("#price-range").length && $("#price-range").val() != priceRangeStart + "," + priceRangeEnd && (filterArray.price = $("#price-range").val()), filterArray.sort = $("#list-sort-by .dropdown-selected").attr("data-value"), filterArray.pagesize = $("#page-size-slt .dropdown-selected").attr("data-value"), filterArray
	},
	mobileAjaxFilter = function() {
		if (filterArray = getFilterCondition(), void 0 !== filterArray.attrs && (1 === Object.keys(filterArray).length || 2 === Object.keys(filterArray).length && void 0 !== filterArray.sort) && -1 !== $.inArray(filterArray.attrs, [__("women"), __("men"), __("kids")])) {
			var pathName = window.location.pathname;
			if ("/eyeglasses" === pathName || "/sunglasses" === pathName) return location.href = window.location.origin + pathName + "/" + filterArray.attrs, !1
		}
		1 < mobFilterUrl.split("?").length && (pair = mobFilterUrl.split("?")[1].split("="), filterArray[pair[0]] = pair[1], -1 != mobFilterUrl.indexOf("enablep==0") && (mobFilterUrl = mobFilterUrl.replace("enablep==0", "enablep==1")));
		var hashValObj = $.hash.get(!0);
		$.each(hashValObj, function(k, v) {
			"" == v && void 0 === filterArray[k] && (filterArray[k] = v)
		}), $.param(filterArray) ? $.hash.set(filterArray) : "" != hashVal && $.hash.set("/");
		var _brandsLength, _allLength, _dataList = $.hash.get(!0);
		void 0 !== _dataList.attrs && "" != _dataList.attrs ? (void(_brandsLength = 0) !== _dataList.brands && "" != _dataList.brands && (_brandsLength = _dataList.brands.split(",").length), _allLength = _brandsLength + _dataList.attrs.split(",").length, $(".js-filter-num").html("(" + _allLength + ")"), $(".sort-filter-number").html(_allLength).show(), $(".ab-js-open-filter").addClass("active")) : ($(".js-filter-num").html(""), $(".sort-filter-number").hide().html(""), $(".ab-js-open-filter").removeClass("active")), "undefined" == typeof SEARCH_FILTER && scrollToAnchor()
	},
	initRangeSlider = function() {
		var readHash = $.hash.get(!0);
		null != readHash.length && "" != readHash.length ? $("#size-length").ionRangeSlider("update", {
			from: readHash.length.split(",")[0],
			to: readHash.length.split(",")[1]
		}) : $("#size-length").ionRangeSlider("update", {
			from: sizeStarts,
			to: sizeEnds
		}), null != readHash.width && "" != readHash.width ? $("#size-width").ionRangeSlider("update", {
			from: readHash.width.split(",")[0],
			to: readHash.width.split(",")[1]
		}) : $("#size-width").ionRangeSlider("update", {
			from: sizeStart,
			to: sizeEnd
		}), null != readHash.lens && "" != readHash.lens ? $("#size-lens-width").ionRangeSlider("update", {
			from: readHash.lens.split(",")[0],
			to: readHash.lens.split(",")[1]
		}) : $("#size-lens-width").ionRangeSlider("update", {
			from: lensSizeStart,
			to: lensSizeEnd
		}), null != readHash.height && "" != readHash.height ? $("#size-lens-height").ionRangeSlider("update", {
			from: readHash.height.split(",")[0],
			to: readHash.height.split(",")[1]
		}) : $("#size-lens-height").ionRangeSlider("update", {
			from: lensHeightStart,
			to: lensHeightEnd
		}), null != readHash.bridge && "" != readHash.bridge ? $("#size-nose-bridge").ionRangeSlider("update", {
			from: readHash.bridge.split(",")[0],
			to: readHash.bridge.split(",")[1]
		}) : $("#size-nose-bridge").ionRangeSlider("update", {
			from: bridgeSizeStart,
			to: bridgeSizeEnd
		}), null != readHash.price && "" != readHash.price ? $("#price-range").ionRangeSlider("update", {
			from: readHash.price.split(",")[0],
			to: readHash.price.split(",")[1]
		}) : $("#price-range").ionRangeSlider("update", {
			from: priceRangeStart,
			to: priceRangeEnd
		})
	},
	initFilter = function(tmpList, normal) {
      if(location.href.indexOf("select-lenses") > -1){ return false;}
      
		for (var i in normal = normal || !1, void 0 !== tmpList.attrs ? tmpList.attrs = 0 === tmpList.attrs.length ? "" : tmpList.attrs.split(",") : "" !== $("#glasses-list-box").data("attrs") && (tmpList.attrs = $("#glasses-list-box").data("attrs").split(",")), void 0 !== tmpList.brands ? tmpList.brands = 0 === tmpList.brands.length ? "" : tmpList.brands.split(",") : void 0 !== $("#glasses-list-box").data("brands") && "" != $("#glasses-list-box").data("brands") && (tmpList.brands = $("#glasses-list-box").data("brands").split(",")), void 0 !== tmpList.color ? tmpList.color = 0 === tmpList.color.length ? "" : tmpList.color.split(",") : void 0 !== $("#glasses-list-box").data("colors") && "" !== $("#glasses-list-box").data("colors") && (tmpList.color = $("#glasses-list-box").data("colors").split(",")), void 0 !== tmpList.gtype && tmpList.gtype && (tmpList.gtype = tmpList.gtype.split(",")), void 0 !== tmpList.weight && tmpList.weight && (tmpList.weight = tmpList.weight.split(",")), "desktop" == device ? $("#js-filter .option").not(".custom").removeClass("selected") : $("#js-filter .option").removeClass("selected"), tmpList) {
			if ("attrs" === i || "color" === i || "gtype" === i || "weight" === i || "brands" === i)
				for (var tmpArr = tmpList[i], j = 0; j < tmpArr.length; j++) $("#js-filter li").find('dd[data-param="' + i + '"][data-' + i + '="' + tmpArr[j] + '"]').addClass("selected");
			"prescription" === i && (tmpList[i] ? ($("#js-prescription").find(".option").removeClass("none").addClass("selected"), $("#js-prescription").find(".lens-txt").addClass("none")) : 1 == $.cookie("is_login") && 0 != $prescription.find(".choose-current").length || $eligible.addClass("none")), "width" !== i && "length" !== i && "lens" !== i && "bridge" !== i && "height" !== i || tmpList[i] && $("#js-filter .custom").addClass("selected"), "price" === i && tmpList[i] && $("#js-filter .price-limite").addClass("selected")
		}
		"desktop" != device && setFilterName(), showFilterTitle(), normal || $.ajaxListLoad(tmpList)
	},
	$filterBox = $("#js-filter-out");
"desktop" == device ? $filterBox.stickFilter() : ($(".list-type").stickFilter({
	fixClass: "fix-list-type"
}), $filterBox.appendTo($(".wrapper-container")));
var filteronload = function() {
	var $filterList = $("#js-filter li"),
		$openFilter = $(".ab-js-open-filter"),
		$closeFilter = $("#js-filter-out .close-filter"),
		$filter = $("#js-filter-out .filter"),
		$filteContent = $("#js-filter"),
		$clearResult = $("#js-filter-out .filter-clear"),
		$filterApply = $(".btn-apply");
	var sizeChange = function(attr) {
			var tmpArr, dataList = $.hash.get(!0);
			if (tmpArr = void 0 !== dataList[attr] ? dataList[attr].split(",") : "" !== $("#glasses-list-box").data("attrs") ? $("#glasses-list-box").data("attrs").split(",") : "")
				for (var i in tmpAttrs = "", tmpArr) 0 <= $.inArray(tmpArr[i], ["xs", "s", "m", "l", "xl"]) || "function" != typeof tmpArr[i] && (tmpAttrs += tmpAttrs ? "," + tmpArr[i] : tmpArr[i]);
			else var tmpAttrs = "";
			return dataList[attr] = tmpAttrs, dataList.page = 1, $("#js-filter .custom").addClass("selected").siblings().removeClass("selected"), showFilterTitle(), dataList
		},
		priceChange = function(attr) {
			var tmpArr, dataList = $.hash.get(!0);
			if (tmpArr = void 0 !== dataList[attr] ? dataList[attr].split(",") : "" !== $("#glasses-list-box").data("attrs") ? $("#glasses-list-box").data("attrs").split(",") : "")
				for (var i in tmpAttrs = "", tmpArr) "function" != typeof tmpArr[i] && (tmpAttrs += tmpAttrs ? "," + tmpArr[i] : tmpArr[i]);
			else var tmpAttrs = "";
			return dataList[attr] = tmpAttrs, dataList.page = 1, $("#js-filter .price-limite").addClass("selected").siblings().removeClass("selected"), showFilterTitle(), dataList
		},
		getOriginData = function() {
			var rxContainer = $("#rx-prescription-wrapper");
			return data = rxContainer.find("input").add("select").add("checkbox").not($("#select_prescription")).serialize().replace(/\+/g, "%20"), data = data.replace(/&/g, '","'), data = data.replace(/=/g, '":"'), data = data ? decodeURIComponent('{"' + data + '"}') : null, data
		},
		resetRangeSlider = function(dataList) {
			return $("#size-width").ionRangeSlider("update", {
				from: sizeStart,
				to: sizeEnd
			}), $("#size-length").ionRangeSlider("update", {
				from: sizeStarts,
				to: sizeEnds
			}), $("#size-lens-width").ionRangeSlider("update", {
				from: lensSizeStart,
				to: lensSizeEnd
			}), $("#size-lens-height").ionRangeSlider("update", {
				from: lensHeightStart,
				to: lensHeightEnd
			}), $("#size-nose-bridge").ionRangeSlider("update", {
				from: bridgeSizeStart,
				to: bridgeSizeEnd
			}), delete dataList.width, delete dataList.length, delete dataList.lens, delete dataList.height, delete dataList.bridge, dataList
		},
		initRx = function(rx) {
			osSph.add(osCyl).add(odSph).add(odCyl).each(function() {
				return void 0 === rx[$(this).attr("name")] || "0.00" == rx[$(this).attr("name")] ? ($(this).val("0.00"), !0) : void $(this).val(rx[$(this).attr("name")]).trigger("change")
			}), osAxis.add(odAxis).add(osAdd).add(odAdd).add(pd).add(npd).add(osPd).add(odPd).each(function() {
				return void 0 === rx[$(this).attr("name")] || "0.00" == rx[$(this).attr("name")] || "" == rx[$(this).attr("name")] || "0.0" == rx[$(this).attr("name")] ? ($(this).val(""), !0) : void $(this).val(rx[$(this).attr("name")]).trigger("change")
			}), odPrismnumV.add(osPrismnumV).add(odPrismdirV).add(osPrismdirV).add(odPrismnumH).add(osPrismnumH).add(odPrismdirH).add(osPrismdirH).each(function() {
				return void 0 === rx[$(this).attr("name")] || "0.00" == rx[$(this).attr("name")] || "" == rx[$(this).attr("name")] ? ($(this).val("n/a"), !0) : void $(this).val(rx[$(this).attr("name")]).trigger("change")
			}), !pd.val() && osPd.val() || null != rx.noSamePd ? noSamePd.prop("checked", !0).trigger("change") : noSamePd.prop("checked", !1).trigger("change"), 0 < rxId.length && rxId && rxId.val(rx.rx_id), null != rx.is_prism && 1 == rx.is_prism ? (prism.prop("checked", !0).trigger("change"), 0 == $(".js-btn-show-more-rx").hasClass("show-more") && $(".js-btn-show-more-rx").trigger("click")) : prism.prop("checked", !1).trigger("change")
		};
	$("#size-width").ionRangeSlider({
		min: sizeStart,
		max: sizeEnd,
		from: sizeStart,
		to: sizeEnd,
		type: "double",
		step: 1,
		hasGrid: !1,
		hideMinMax: !0,
		hideFromTo: !0,
		onChange: function() {
			var tmpSize = $("#size-width").val().split(",");
			$("#size-width-start").html(tmpSize[0] + "mm"), $("#size-width-end").html(tmpSize[1] + "mm"), sizeStart == tmpSize[0] && sizeEnd == tmpSize[1] || (sizeChange("attrs").width = tmpSize)
		},
		onFinish: function() {
			var dataList = sizeChange("attrs");
			dataList.width = $("#size-width").val(), "desktop" == device ? $.hash.set(dataList) : mobileAjaxFilter()
		}
	}), $("#size-length").ionRangeSlider({
		min: sizeStarts,
		max: sizeEnds,
		from: sizeStarts,
		to: sizeEnds,
		type: "double",
		step: 1,
		hasGrid: !1,
		hideMinMax: !0,
		hideFromTo: !0,
		onChange: function() {
			var tmpSize = $("#size-length").val().split(",");
			$("#size-length-start").html(tmpSize[0] + "mm"), $("#size-length-end").html(tmpSize[1] + "mm"), sizeStarts == tmpSize[0] && sizeEnds == tmpSize[1] || (sizeChange("attrs").length = tmpSize)
		},
		onFinish: function() {
			var dataList = sizeChange("attrs");
			dataList.length = $("#size-length").val(), "desktop" == device ? $.hash.set(dataList) : mobileAjaxFilter()
		}
	}), $("#size-lens-width").ionRangeSlider({
		min: lensSizeStart,
		max: lensSizeEnd,
		from: lensSizeStart,
		to: lensSizeEnd,
		type: "double",
		step: 1,
		hasGrid: !1,
		hideMinMax: !0,
		hideFromTo: !0,
		onChange: function() {
			var tmpSize = $("#size-lens-width").val().split(",");
			$("#size-lens-width-start").html(tmpSize[0] + "mm"), $("#size-lens-width-end").html(tmpSize[1] + "mm"), lensSizeStart == tmpSize[0] && lensSizeEnd == tmpSize[1] || (sizeChange("attrs").lens = tmpSize)
		},
		onFinish: function() {
			var dataList = sizeChange("attrs");
			dataList.lens = $("#size-lens-width").val(), "desktop" == device ? $.hash.set(dataList) : mobileAjaxFilter()
		}
	}), $("#size-lens-height").ionRangeSlider({
		min: lensHeightStart,
		max: lensHeightEnd,
		from: lensHeightStart,
		to: lensHeightEnd,
		type: "double",
		step: 1,
		hasGrid: !1,
		hideMinMax: !0,
		hideFromTo: !0,
		onChange: function() {
			var tmpSize = $("#size-lens-height").val().split(",");
			$("#size-lens-height-start").html(tmpSize[0] + "mm"), $("#size-lens-height-end").html(tmpSize[1] + "mm"), lensHeightStart == tmpSize[0] && lensHeightEnd == tmpSize[1] || (sizeChange("attrs").height = tmpSize)
		},
		onFinish: function() {
			var dataList = sizeChange("attrs");
			dataList.height = $("#size-lens-height").val(), "desktop" == device ? $.hash.set(dataList) : mobileAjaxFilter()
		}
	}), $("#size-nose-bridge").ionRangeSlider({
		min: bridgeSizeStart,
		max: bridgeSizeEnd,
		from: bridgeSizeStart,
		to: bridgeSizeEnd,
		type: "double",
		step: 1,
		hasGrid: !1,
		hideMinMax: !0,
		hideFromTo: !0,
		onChange: function() {
			var tmpSize = $("#size-nose-bridge").val().split(",");
			$("#size-nose-bridge-start").html(tmpSize[0] + "mm"), $("#size-nose-bridge-end").html(tmpSize[1] + "mm"), bridgeSizeStart == tmpSize[0] && bridgeSizeEnd == tmpSize[1] || (sizeChange("attrs").bridge = tmpSize)
		},
		onFinish: function() {
			var dataList = sizeChange("attrs");
			dataList.bridge = $("#size-nose-bridge").val(), "desktop" == device ? $.hash.set(dataList) : mobileAjaxFilter()
		}
	}), "desktop" != device && (priceRangeStart = parseInt($("#price-range-start").attr("data-defaul-min")), priceRangeEnd = parseInt($("#price-range-end").attr("data-defaul-max"))), $("#price-range").ionRangeSlider({
		min: priceRangeStart,
		max: priceRangeEnd,
		from: priceRangeStart,
		to: priceRangeEnd,
		type: "double",
		step: 1,
		hasGrid: !1,
		hideMinMax: !0,
		hideFromTo: !0,
		onChange: function() {
			var tmpPrice = $("#price-range").val().split(",");
			$("#price-range-start").html("$" + tmpPrice[0]), $("#price-range-end").html("$" + tmpPrice[1]), priceRangeStart == tmpPrice[0] && priceRangeEnd == tmpPrice[1] || (priceChange("attrs").price = tmpPrice)
		},
		onFinish: function() {
			var dataList = priceChange("attrs");
			dataList.price = $("#price-range").val(), "desktop" == device ? $.hash.set(dataList) : mobileAjaxFilter()
		}
	});
	var updateRange = function() {
			var sizeCustom, updateHash = $.hash.get(!0),
				priceLimeted = !1;
			$(".js-group-lens-price ").find(".price-limite").hasClass("selected") && (priceLimeted = !0), priceLimeted && null != updateHash.price && "" != updateHash.price ? $("#price-range").ionRangeSlider("update", {
				from: updateHash.price.split(",")[0],
				to: updateHash.price.split(",")[1]
			}) : $("#price-range").ionRangeSlider("update", {
				from: priceRangeStart,
				to: priceRangeEnd
			}), 0 != $("#size-width").length && (sizeCustom = !0, $(".js-group-size ").find(".custom").hasClass("selected") || (sizeCustom = !1), sizeCustom && null != updateHash.length && "" != updateHash.length ? $("#size-length").ionRangeSlider("update", {
				from: updateHash.length.split(",")[0],
				to: updateHash.length.split(",")[1]
			}) : $("#size-length").ionRangeSlider("update", {
				from: sizeStarts,
				to: sizeEnds
			}), sizeCustom && null != updateHash.width && "" != updateHash.width ? $("#size-width").ionRangeSlider("update", {
				from: updateHash.width.split(",")[0],
				to: updateHash.width.split(",")[1]
			}) : $("#size-width").ionRangeSlider("update", {
				from: sizeStart,
				to: sizeEnd
			}), sizeCustom && null != updateHash.lens && "" != updateHash.lens ? $("#size-lens-width").ionRangeSlider("update", {
				from: updateHash.lens.split(",")[0],
				to: updateHash.lens.split(",")[1]
			}) : $("#size-lens-width").ionRangeSlider("update", {
				from: lensSizeStart,
				to: lensSizeEnd
			}), sizeCustom && null != updateHash.height && "" != updateHash.height ? $("#size-lens-height").ionRangeSlider("update", {
				from: updateHash.height.split(",")[0],
				to: updateHash.height.split(",")[1]
			}) : $("#size-lens-height").ionRangeSlider("update", {
				from: lensHeightStart,
				to: lensHeightEnd
			}), sizeCustom && null != updateHash.bridge && "" != updateHash.bridge ? $("#size-nose-bridge").ionRangeSlider("update", {
				from: updateHash.bridge.split(",")[0],
				to: updateHash.bridge.split(",")[1]
			}) : $("#size-nose-bridge").ionRangeSlider("update", {
				from: bridgeSizeStart,
				to: bridgeSizeEnd
			}))
		},
		originRxCompare, rxEvent = function() {
			rxConfirm.on("click", function() {
				$.cookie("rx-filter", getOriginData(), {
					path: "/"
				}), $("#js-eligible").removeClass("none").addClass("selected"), $("#js-prescription").find(".lens-txt").addClass("none");
				var dataList = $.hash.get(!0),
					timestamp = (new Date).getTime();
				dataList.prescription = timestamp, "desktop" == device ? ($.hash.set(dataList), scrollToAnchor()) : mobileAjaxFilter(), $("#popup-window .popup-close").trigger("click")
			}), odAdd.add(osAdd).on("change", function() {
				osAdd.val() || odAdd.val() ? nearPdBox.show() : (nearPdBox.hide(), haveNearPd.prop("checked", !1).trigger("change"), npd.val(""))
			}), haveNearPd.on("change", function() {
				1 == $(this).prop("checked") ? npd.closest("ul").show() : npd.closest("ul").hide()
			}), noSamePd.on("change", function() {
				1 == $(this).prop("checked") ? (pd.hide(), odPd.show(), osPd.show(), pd.closest("li").hide(), odPd.closest("li").show(), osPd.closest("li").show()) : (pd.show(), odPd.hide(), osPd.hide(), pd.closest("li").show(), odPd.closest("li").hide(), osPd.closest("li").hide())
			}), prism.on("change", function() {
				1 == $(this).prop("checked") ? jsPrismWrapper.slideDown() : jsPrismWrapper.slideUp()
			})
		},
		firstReset, clearHeight, closeHeight, heightResize, currentHash, tmpList, tmpList;
	$.triggerRxEvent = function() {
		$(".js-enter-rx").off("click").on("click", function() {
			function rxPopup() {
				var className = "desktop" == device ? ["full-rx-popup", "full-rx-desktop-popup", "popup-rx-help-wrapper"] : ["full-rx-popup", "popup-rx-help-wrapper"];
				$.popup("#rx-popup", {
					class_name: className,
					overlay: {
						class_name: "full-rx-overlay"
					},
					inputFocus: !1
				}, function() {
					$(".popup-rx-help-wrapper").css("max-height", $(window).height() + "px")
				}, function() {
					1 == $.cookie("is_login") && null != originRxCompare && originRxCompare != getOriginData() && 0 < $(".js-use-prescription").length && ($(".js-cusom-rx").removeClass("none"), $(".js-use-prescription").val("custom prescription"), $(".js-cusom-rx").attr("data-value", "jason:" + $.cookie("rx-filter")))
				})
			}
			0 == $("#rx-popup").html().length ? $(this).ajaxAuto({
				success: function(response) {
					"ok" == response.status && ($("#rx-popup").html(response.data.html), rxPopup(), rxEvent(), $.triggerInitRx())
				}
			}) : (rxPopup(), $.triggerInitRx()), originRxCompare = getOriginData()
		}), $prescription.on("click", ".option", function() {
			var defaultPrescription, timestamp, dataList;
			$(this).toggleClass("selected"), $(this).hasClass("selected") ? (originRxCompare = getOriginData(), 1 == $.cookie("is_login") && 0 < $(".js-use-prescription").length && (defaultPrescription = $(".js-use-prescription").find("option:selected").data("value").substr(6), $.cookie("rx-filter", defaultPrescription, {
				path: "/"
			})), dataList = $.hash.get(!0), timestamp = (new Date).getTime(), dataList.prescription = timestamp) : (1 != $.cookie("is_login") && $eligible.addClass("none"), (dataList = $.hash.get(!0)).prescription = ""), "desktop" == device && ($.hash.set(dataList), scrollToAnchor())
		}), $(".js-use-prescription").on("change", function() {
			var rxValue = $(this).find("option:selected").data("value").substr(6);
			$.cookie("rx-filter", rxValue, {
				path: "/"
			}), $prescription.find(".option").addClass("selected");
			var dataList = $.hash.get(!0),
				timestamp = (new Date).getTime();
			dataList.prescription = timestamp, "desktop" == device && $.hash.set(dataList)
		})
	}, $.triggerInitRx = function() {
		var rxValue, defaultPrescription, rxValue;
		null != $.cookie("rx-filter") && (rxValue = eval("(" + $.cookie("rx-filter") + ")"), initRx(rxValue)), 1 == $.cookie("is_login") && (null == $.cookie("rx-filter") || null == $.cookie("rx-filter")) && 0 < $(".js-use-prescription").length && (defaultPrescription = $(".js-use-prescription").find("option:selected").data("value").substr(6), $.cookie("rx-filter", defaultPrescription, {
			path: "/"
		}), rxValue = eval("(" + defaultPrescription + ")"), initRx(rxValue))
	}, "desktop" == device ? ($("#js-filter li").on("mouseenter", function() {
		$(this).addClass("current").siblings("li").removeClass("current")
	}), $("#js-filter li.js-group-size").on("mouseenter", function() {
		updateRange()
	}), $("#js-filter li.js-group-lens-price").on("mouseenter", function() {
		updateRange()
	}), $("#js-filter").on("mouseleave", function(e) {
		(e.relatedTarget || e.toElement) && $(".filter ul li").removeClass("current")
	}), $(window).on("resize", function() {
		$(".filter-out").css("width", $("#container").width())
	})) : (firstReset = !0, $filterList.on("click", ".filter-menu", function(e) {
		$$ = $(this).parent("li"), $$.addClass("current").siblings().removeClass("current").find(".filter-down").slideUp(), $(this).next(".filter-down").stop().slideToggle("normal", function() {
			"none" == $(this).css("display") ? $$.removeClass("current") : ($$.hasClass("js-group-lens-type") && $("#js-filter").scrollTop($("#js-filter")[0].scrollHeight), $$.hasClass("js-group-color") && $("#js-filter").animate({
				scrollTop: ($$.find(".filter-menu").outerHeight(!0) + 1) * $$.data("number")
			}, 1e3))
		}), ($$.hasClass("js-group-size") || $$.hasClass("js-group-lens-price")) && ($$.find(".custom").hasClass("selected") && $$.find(".price-limite").hasClass("selected") && !firstReset || (updateRange(), firstReset = !1)), e.preventDefault()
	}), clearHeight = $clearResult.outerHeight(!0), closeHeight = $closeFilter.outerHeight(!0), heightResize = function(adjust) {
      console.log(111)
		var height = $(window).height() - $clearResult.outerHeight(!0) - $closeFilter.outerHeight(!0);
		adjust ? $filteContent.stop().animate({
			height: height
		}, "150") : $filteContent.css("height", height)
	}, "desktop" == device && $openFilter.on("click", function() {
		$filter.slideToggle(), heightResize(!1), "none" == $(".js-filter-out").css("display") ? ($("body").css({
			height: "auto",
			"overflow-y": "auto"
		}), $("html").removeClass("ios-modal-fix")) : (updateRange(), $("body").css({
			height: $(window).height(),
			"overflow-y": "hidden"
		}), $("html").addClass("ios-modal-fix"))
	}), $filterApply.on("click", function() {
		$closeFilter.click()
	}), $closeFilter.on("click", function() {
		$("html, body").animate({
			scrollTop: $("body").attr("data-scroll") + "px"
		}, {
			duration: 100,
			easing: "swing"
		}), $filter.slideUp(), $("body").css({
			height: "auto",
			"overflow-y": "auto"
		}), $("html").removeClass("ios-modal-fix")
	}), $(window).on("resize", function() {
		"none" != $(".js-filter-out").css("display") && heightResize(!0), $("#size-width").ionRangeSlider("update"), $("#size-length").ionRangeSlider("update"), $("#size-lens-width").ionRangeSlider("update"), $("#size-lens-height").ionRangeSlider("update"), $("#size-nose-bridge").ionRangeSlider("update"), $("#price-range").ionRangeSlider("update")
	}));

	"undefined" == typeof SEARCH_FILTER && (currentHash = $.hash.get(), "" !== currentHash ? (tmpList = $.hash.parse("/", currentHash), initFilter(tmpList)) : location.search ? (tmpList = $.hash.parse("&", location.search.substr(1)), initFilter(tmpList, !0)) : initFilter([], !0), initRangeSlider()), 

	$filterList.on("click", ".option", function(e) {
		if (e.preventDefault(), $(this).hasClass("custom") || "js-prescription" == $(this).prop("id")) return !1; - 1 != filterUrl.indexOf("enablep=0") && (filterUrl = filterUrl.replace("enablep=0", "enablep=1"));
		var tmpAttrs, attr = $(this).data("param"),
			attrVal = $(this).data(attr),
			dataList = $.hash.get(!0),
			query = location.search;
		if (query) {
			var queryType = $.hash.parse("&", query.substr(1));
			for (gt in queryType) void 0 === dataList[gt] && (dataList[gt] = queryType[gt])
		}
		if ("size" != $(this).data("group") || $(this).hasClass("custom") || $(this).siblings(".custom").removeClass("selected"), "attrs" === attr || "color" === attr || "gtype" === attr || "weight" === attr || "brands" === attr)
			if ($(this).hasClass("selected")) {
				if (void 0 !== dataList[attr]) {
					var tmpArr = dataList[attr].split(","),
						newAttrs = "";
					for (var i in tmpArr) attrVal !== tmpArr[i] && (newAttrs += newAttrs ? "," + tmpArr[i] : tmpArr[i]);
					dataList[attr] = newAttrs
				} else {
					if ("attrs" === attr || "color" === attr) {
						if ("" !== $("#glasses-list-box").data(attr))
							for (var defaultAttrs = $("#glasses-list-box").data("color" == attr ? "colors" : attr).split(","), newAttrs = "", i = 0; i < defaultAttrs.length; i++) attrVal !== defaultAttrs[i] && (newAttrs += newAttrs ? "," + defaultAttrs[i] : defaultAttrs[i])
					} else if (void 0 !== $("#glasses-list-box").data(attr) && "brands" === attr && "" !== $("#glasses-list-box").data(attr))
						for (var defaultBrands = $("#glasses-list-box").data("brands").split(","), newAttrs = "", i = 0; i < defaultBrands.length; i++) attrVal !== defaultBrands[i] && (newAttrs += newAttrs ? "," + defaultBrands[i] : defaultBrands[i]);
					else newAttrs = "";
					dataList[attr] = newAttrs
				}
				$(this).removeClass("selected")
			} else {
				void 0 !== dataList[attr] ? (tmpAttrs = dataList[attr], tmpAttrs += "" !== dataList[attr] ? "," + attrVal : attrVal) : tmpAttrs = (tmpAttrs = "") === $("#glasses-list-box").data(attr) || "attrs" !== attr && "color" !== attr ? "brands" === attr && void 0 !== $("#glasses-list-box").data(attr) && "" !== $("#glasses-list-box").data(attr) ? attrVal + "," + $("#glasses-list-box").data("brands") : attrVal : attrVal + "," + $("#glasses-list-box").data("color" == attr ? "colors" : attr), dataList[attr] = tmpAttrs, $(this).addClass("selected")
			}
		if ("xs" === attrVal || "s" === attrVal || "m" === attrVal || "l" === attrVal || "xl" === attrVal) {
			var showDemensions = !1;
			if (void 0 !== dataList[attr]) {
				tmpArr = dataList[attr].split(",");
				for (var i in tmpArr) {
					if (-1 !== $.inArray(tmpArr[i], ["xs", "s", "m", "l", "xl"])) {
						showDemensions = !0;
						break
					}
				}
			}
			showDemensions && (dataList = resetRangeSlider(dataList))
		}
		dataList.page = 1;
		tmpArr = [];
		if ($.each(dataList, function(key, v) {
				"" !== v && -1 !== $.inArray(key, ["attrs", "color", "weight", "brands", "price", "length", "lens", "bridge", "height"]) && tmpArr.push(key)
			}), "desktop" == device) {
			if (1 === tmpArr.length && void 0 !== dataList.attrs && -1 !== $.inArray(dataList.attrs, [__("women"), __("men"), __("kids")])) {
				var pathName = window.location.pathname;
				if (pathName == "/" + __("sunglasses") + "/" + __("reading") && (pathName = "/" + __("sunglasses") + "sunglasses"), pathName === "/" + __("eyeglasses") || pathName === "/" + __("sunglasses")) return location.href = window.location.origin + pathName + "/" + dataList.attrs, !1
			}
			$.hash.set(dataList), scrollToAnchor()
		} else setFilterName(), $.hash.set(dataList), mobileAjaxFilter();
		showFilterTitle()
	}), $filterList.on("click", ".custom", function() {
		-1 != filterUrl.indexOf("enablep=0") && (filterUrl = filterUrl.replace("enablep=0", "enablep==1"));
		var dataList, attr = $(this).data("param");
		$(this).hasClass("selected") ? ($(this).removeClass("selected"), dataList = $.hash.get(!0), dataList = resetRangeSlider(dataList), showFilterTitle()) : dataList = sizeChange(attr), "desktop" == device ? ($.hash.set(dataList), scrollToAnchor()) : setFilterName()
	}), $("#js-filter-clear").on("click", function() {
		var defaultAttrs = $(this).data("default-attr"),
			brands = ($(this).data("default-price"), $(this).data("default-brands"));
		$("#js-filter li").removeClass("filtered"), $("#js-filter li").find(".js-filtered-name").removeClass("filtered-name").html(""), $("#js-filter .option").removeClass("selected"), $("#glasses-list-box").data("attrs", defaultAttrs), $("#glasses-list-box").data("brands", brands);
		var currentHash = $.hash.get();
		if ("desktop" != device) {
			if ($closeFilter.click(), mobileAjaxFilter(), !currentHash) return initRangeSlider(), showFilterTitle(), !1
		} else scrollToAnchor();
		var dataList = {};
		resetRangeSlider(dataList), dataList.attrs = null != defaultAttrs ? defaultAttrs : "", dataList.sort = $("#list-sort-by .dropdown-selected").attr("data-value"), dataList.pagesize = $("#page-size-slt .dropdown-selected").attr("data-value");
		var query = location.search;
		query && (dataList = Object.assign(dataList, $.hash.parse("&", query.substr(1)))), $.hash.set(dataList)
	}), "undefined" != typeof filterRxUrl && $.ajax({
		url: filterRxUrl,
		dataType: "json",
		success: function(respon) {
			"ok" == respon.status && ($("#js-prescription").html(respon.data.list), $.triggerRxEvent(), selectRxOption(), $.hash.parse("/", $.hash.get()).prescription && ($("#js-prescription").find(".option").removeClass("none").addClass("selected"), $("#js-prescription").find(".lens-txt").addClass("none")))
		}
	}), $("#helps").each(function(i) {
		var $$ = $(this);
		$$.off("click").on("click", function(event) {
			event.stopPropagation()
		});
		var tipTxt = $$.next().html();
		$$.tooltip(tipTxt, {
			context_position: "center top-20",
			target_position: "center/7.5 bottom",
			arrow_tip: {
				direction: "bottom",
				offset: "7.5%",
				height: "15"
			}
		})
	}), selectRxOption()
};
"desktop" == device && $(document).ready(function() {
	filteronload()
}), $.execute = function(params) {
	currenAjax && currenAjax.abort(), initFilter(params)
}, 0 == bannerLoaded && setTimeout("ajaxReplaceSmallBanner()", 2e3), window.onresize = function() {
	704 <= $(document).width() && 0 < $("#filter li .filter-title").length && $("#filter li .filter-title").siblings("dl").show(), "desktop" != device && upateSmallBannerPosition()
};
var toggleProductBottom = function(hide) {
		hide ? ($("#pagination").hide(), $("#js-catalog-bottom").hide()) : ($("#pagination").show(), $("#js-catalog-bottom").show())
	},
	selectRxOption = function() {
		var rxFilterCookie;
		void 0 !== $.cookie("rx-filter") && null !== $.cookie("rx-filter") && 0 < $(".js-use-prescription").length && (rxFilterCookie = eval("(" + $.cookie("rx-filter") + ")"), void 0 !== rxFilterCookie.rx_name && 0 < $(".js-use-prescription option[value='" + rxFilterCookie.rx_name + "']").length && $(".js-use-prescription").val(rxFilterCookie.rx_name))
	};

function catalogFilter(filterKey, filterVal) {
	if ("speedoffer" == filterKey) {
		var speedObj = $("#js-filter dd[data-attrs='speedoffer']");
		if (null == speedObj.data("param") || null == speedObj.data("param") || speedObj.hasClass("selected")) return !1;
		speedObj.addClass("selected");
		var attr = speedObj.data("param"),
			attrVal = speedObj.data(attr)
	} else if ("brands" == filterKey) {
		var val = "data-brands='" + filterVal.toLowerCase(),
			brandObj = $("#js-filter dd[" + val + "']");
		if (null == brandObj.data("param") || null == brandObj.data("param") || brandObj.hasClass("selected")) return !1;
		brandObj.addClass("selected");
		attr = brandObj.data("param"), attrVal = brandObj.data(attr)
	}
	var tmpAttrs, dataList = $.hash.get(!0);
	void 0 !== dataList[attr] ? (tmpAttrs = dataList[attr], tmpAttrs += "" !== dataList[attr] ? "," + attrVal : attrVal) : tmpAttrs = (tmpAttrs = "") !== $("#glasses-list-box").data(attr) && "attrs" === attr ? attrVal + "," + $("#glasses-list-box").data("attrs") : "brands" === attr && void 0 !== $("#glasses-list-box").data(attr) && "" !== $("#glasses-list-box").data(attr) ? attrVal + "," + $("#glasses-list-box").data("brands") : attrVal, dataList[attr] = tmpAttrs, "desktop" == device ? ($.hash.set(dataList), scrollToAnchor()) : (setFilterName(), mobileAjaxFilter())
}

function updateRange() {
	var sizeCustom, updateHash = $.hash.get(!0),
		priceLimeted = !1;
	$(".js-group-lens-price ").find(".price-limite").hasClass("selected") && (priceLimeted = !0), priceLimeted && null != updateHash.price && "" != updateHash.price ? $("#price-range").ionRangeSlider("update", {
		from: updateHash.price.split(",")[0],
		to: updateHash.price.split(",")[1]
	}) : $("#price-range").ionRangeSlider("update", {
		from: priceRangeStart,
		to: priceRangeEnd
	}), 0 != $("#size-width").length && (sizeCustom = !0, $(".js-group-size ").find(".custom").hasClass("selected") || (sizeCustom = !1), sizeCustom && null != updateHash.length && "" != updateHash.length ? $("#size-length").ionRangeSlider("update", {
		from: updateHash.length.split(",")[0],
		to: updateHash.length.split(",")[1]
	}) : $("#size-length").ionRangeSlider("update", {
		from: sizeStarts,
		to: sizeEnds
	}), sizeCustom && null != updateHash.width && "" != updateHash.width ? $("#size-width").ionRangeSlider("update", {
		from: updateHash.width.split(",")[0],
		to: updateHash.width.split(",")[1]
	}) : $("#size-width").ionRangeSlider("update", {
		from: sizeStart,
		to: sizeEnd
	}), sizeCustom && null != updateHash.lens && "" != updateHash.lens ? $("#size-lens-width").ionRangeSlider("update", {
		from: updateHash.lens.split(",")[0],
		to: updateHash.lens.split(",")[1]
	}) : $("#size-lens-width").ionRangeSlider("update", {
		from: lensSizeStart,
		to: lensSizeEnd
	}), sizeCustom && null != updateHash.height && "" != updateHash.height ? $("#size-lens-height").ionRangeSlider("update", {
		from: updateHash.height.split(",")[0],
		to: updateHash.height.split(",")[1]
	}) : $("#size-lens-height").ionRangeSlider("update", {
		from: lensHeightStart,
		to: lensHeightEnd
	}), sizeCustom && null != updateHash.bridge && "" != updateHash.bridge ? $("#size-nose-bridge").ionRangeSlider("update", {
		from: updateHash.bridge.split(",")[0],
		to: updateHash.bridge.split(",")[1]
	}) : $("#size-nose-bridge").ionRangeSlider("update", {
		from: bridgeSizeStart,
		to: bridgeSizeEnd
	}))
}
$(function() {
	$("#glasses-list-box").on("click", ".js-two-day", function(e) {
		catalogFilter("speedoffer")
	}), $("#glasses-list-box").on("click", ".js-brands", function(e) {
		var brandAlt;
		"desktop" != device ? (autoOpen = !1, brandAlt = $(this).attr("alt"), 0 < $("#js-filter").length ? catalogFilter("brands", brandAlt) : ($(".ab-js-open-filter").trigger("click"), setTimeout(function() {
			catalogFilter("brands", brandAlt)
		}, 1500))) : catalogFilter("brands", $(this).attr("alt"))
	})
});
